import { render, staticRenderFns } from "./Checks.vue?vue&type=template&id=a62e08d8&scoped=true&"
import script from "./Checks.vue?vue&type=script&lang=js&"
export * from "./Checks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62e08d8",
  null
  
)

export default component.exports